module.exports = __webpack_public_path__ + "img/04_mzste8_c_scale,w_600.29025c68.jpg";